import { useState } from "react";
import translateFunction from "../translations/translationMain.js";
import { useSelector } from "react-redux";
import Message from "../components/Message.js";
import useColors from "../customHooks/useColors.js";

/*
 isLeaf
*/

const BaseButton = (props) => {
  const {
    onMouseEnter = () => {},
    onMouseLeave = () => {},
    secondaryButton = false,
    disabled = false,
    style = {}, //ide na button element
    children = undefined,
    innerRef = undefined,
    translate = true,
    onClick = () => {},
    error = null,
    hasMarginTop = true,
    cointainerClassName = null
  } = props;

  ////////////////////////////////////////////////////////////////////////////current LANG

  const vButtonText = translate
    ? translateFunction({ key: children })
    : children;

  ////////////////////////////////////////////////////////////////////////////current THEME
  const [currentColors] = useColors();

  ////////////////////////////////////////////////////////////////////////////LOCAL STATES
  const [isHover, setIsHover] = useState(false);

  ////////////////////////////////////////////////////////////////////////////enhanced FUNCTIONS
  const enhancedMouseOver = () => {
    if (onMouseEnter instanceof Function) {
      onMouseEnter();
    }
    setIsHover(true);
  };

  const enhancedMouseLeave = () => {
    if (onMouseLeave instanceof Function) {
      onMouseLeave();
    }
    setIsHover(false);
  };

  const enhancedClick = () => {
    if (onClick instanceof Function) {
      onClick();
    }
  };

  const styles = {
    baseButtonStyle: {
      width: "100%",
      padding: "0.5em",
      marginTop: hasMarginTop ? "1.5em" : "0px",
      transition: "background-color 0.15s ease",
      cursor: "pointer",
      fontSize: "19px"
    },
    primaryButton: {
      backgroundColor: disabled
        ? currentColors.quaternary
        : isHover
        ? currentColors.primary2
        : currentColors.primary,
      color: currentColors.secondary,
      borderWidth: 0,
    },

    secondaryButton: {
      backgroundColor: disabled
        ? currentColors.quaternary
        : isHover
        ? currentColors.primary2
        : currentColors.septenary,
      color: isHover ? currentColors.septenary : currentColors.primary,

      borderWidth: "0.15em",
      borderStyle: "solid",
      borderColor: currentColors.primary,
    },
  };

  const relevantStyle = secondaryButton
    ? styles.secondaryButton
    : styles.primaryButton;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        width: "100%"
      }}
      className = {cointainerClassName}
    >
      <button
        style={{ ...styles.baseButtonStyle, ...relevantStyle, ...style }}
        onMouseEnter={enhancedMouseOver}
        onMouseLeave={enhancedMouseLeave}
        onClick={enhancedClick}
        ref={innerRef}
      >
        {vButtonText}
      </button>
      {(error ?? "") !== "" && <Message isError>{error}</Message>}
    </div>
  );
};

export default BaseButton;
